// extracted by mini-css-extract-plugin
module.exports = {"header":"LoginNav_header__sseMa","link":"LoginNav_link__EMXbE","subLink":"LoginNav_subLink__lP4wj","dropdownFooter":"LoginNav_dropdownFooter__ix7J6"};